<template>
  <header-modal id="error-modal" class="fade"
   headerStyle="alert alert-danger" headerRole="alert">
    <h5 slot="header" class="modal-title" id="modalLabel">
      <i class="fa fa-hand-paper-o" aria-hidden="true"></i> エラー
    </h5>
    <slot>エラーが発生しました。</slot>
    <button slot="footer" type="button" class="btn btn-warning" data-dismiss="modal">OK</button>
  </header-modal>
</template>

<script>
import HeaderModal from 'components/HeaderModal'
import $ from 'jquery'
export default {
  components: {
    HeaderModal
  },
  methods: {
    showModal () {
      $('#error-modal').modal()
    }
  }
}
</script>



// WEBPACK FOOTER //
// ErrorModal.vue?5e3844ee